import React, { Component } from 'react'
import styled, { keyframes } from 'styled-components'
import { StyledSection } from '../styles/elements'
import { colors, media } from '../styles/vars'
import subtitleImg from '../static/images/general/carousel-title.png'
import bgImg from '../static/images/backgrounds/waves2.png'
import ReactAudioPlayer from 'react-audio-player'
import PedalList from '../components/PedalList'
import pedalsData from '../data/pedals.json'
import PedalDetails from '../components/PedalDetails'
import arrowLeft from '../static/images/icons/next_arrow.png'
import arrowRight from '../static/images/icons/back_arrow.png'
import texture from '../static/images/backgrounds/pedal_lines.png'
import { push } from '../analytics'

const infiniteMotion = keyframes`
0%{
    background-position:0 0;
}
50%{
    background-position:-1000px 200px;
}
100%{
    background-position:-2000px 0;
}
`

const Container = styled(StyledSection) `
height:707px;
padding:20px 0;
background-color:#6f4eb7;
background-image:url(${bgImg});
background-position:center bottom;
background-size:1708px;
${
    media.desktop`
    height:initial;
    padding:20px 0 0;
    max-height:980px;
    &:after{
        content:'';
        position:absolute;
        left:0;
        right:0;
        top:0;
        bottom:0;
        background-image:url(${texture});
        animation:${infiniteMotion} 30s linear infinite;
    }
    `
    }
`
const Content = styled.div`
${media.desktop`
position:relative;
z-index:1;
height:100%;
`}
`
const TitleContainer = styled.div`
text-align:left;
width:90%;
max-width:500px;
margin:0 auto;
color:${colors.white};
background-image:url(${texture});
background-position:center right -178px;
background-size:cover;
${
    media.desktop`
    background:none;
    max-width:350px;
    margin-bottom:20px;
    `
    }
`
const Title = styled.h2`
font-size:7rem;
font-weight:700;
text-align:right;
${
    media.desktop`
    font-size:8rem;
    `
    }
`
const SubtitleImage = styled.img`
width:200px;
${
    media.desktop`
    width:230px;
    `
    }
`
const CreditText = styled.label`
font-size:2rem;
display:block;
transform:translate3d(-15px,-4px,0);
`
const ListContainer = styled.div`
position:relative;
z-index:2;
transform:translate3d(0,-185px,0);
${
    media.small`
    transform:translate3d(0,-145px,0);
    `
    }
${
    media.desktop`
    transform:translate3d(0,-190px,0);
    `
    }
`
const DetailsContainer = styled.div`
display:flex;
${
    media.desktop`
    display:block;
    `
    }
`
const ArrowContainer = styled.div`
flex-basis:20%;
flex:1;
background-color:rgba(0, 0, 0, .2);
background-size:50%;
background-repeat:no-repeat;
background-position:center;
${
    media.desktop`
    position:absolute;
    top:0;
    bottom:0;
    margin:auto 0;
    transform:translate3d(0, 100px, 0);
    height:120px;
    width:120px;
    background-color:initial;
    cursor:pointer;
    z-index:10;
    `
    }
`
const DynamicArrowContainer = styled(ArrowContainer) `
background-image:${props => props.left ? `url(${arrowLeft})` : `url(${arrowRight})`};
${
    media.desktop`
    left:${props => props.left ? 0 : 'initial'};
    right:${props => props.left ? 'initial' : 0};
    `
    }
`
const audioFilesPath = './static/pedal_sounds/';
class PedalSection extends Component {
    constructor() {
        super();
        this.handlePlayerClick = this.handlePlayerClick.bind(this);
        this.setCarouselNode = this.setCarouselNode.bind(this);
        this.selectItem = this.selectItem.bind(this);
        this.nextItem = this.nextItem.bind(this);
        this.prevItem = this.prevItem.bind(this);
        this.pauseAudio = this.pauseAudio.bind(this);
        this.handleItemClick = this.handleItemClick.bind(this);
        this.handleAnimationEnd = this.handleAnimationEnd.bind(this);
        this.initAnimation = this.initAnimation.bind(this);

        this.carouselSettings = {
            infinite: true,
            arrows: false,
            speed: 300,
            slidesToShow: 3,
            centerPadding: '5px',
            centerMode: true,
            slidesToScroll: 1,
            afterChange: this.selectItem,
            beforeChange: this.initAnimation,
            responsive: [
                {
                    breakpoint: 420,
                    settings: {
                        centerMode: true,
                        centerPadding: '20px',
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 980,
                    settings: {
                        centerMode: true,
                        centerPadding: '90px',
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };

        this.state = {
            items: pedalsData,
            currentItem: {}
        }
    }
    componentDidMount() {
        this.selectItem(0);
    }
    setCarouselNode(node) {
        this.carousel = node;
    }
    nextItem() {
        this.carousel.slickNext();
        push('Song_Navigation', 'Right');
    }
    prevItem() {
        this.carousel.slickPrev();
        push('Song_Navigation', 'Left');
    }
    selectItem(index) {
        let _items = this.state.items;
        let _activeItem;
        _items.forEach((i, idx) => {
            i.active = index === idx;
            if (i.active) _activeItem = i;
        });
        if (_activeItem === this.state.currentItem) return;

        this.setState({
            items: _items,
            currentItem: _activeItem,
            currentIndex: index
        });
        this.pauseAudio();
    }
    handlePlayerClick() {
        this[this.player.audioEl.paused ? 'playAudio' : 'pauseAudio']();
    }
    playAudio() {
        this.player.audioEl.play();
        this.setState({
            isAudioPlaying: true
        });
        push('Song_Clicked', this.state.currentItem.title);
    }
    pauseAudio() {
        this.player.audioEl.pause();
        if (this.player.audioEl.currentTime)
            this.player.audioEl.currentTime = 0;

        this.setState({
            isAudioPlaying: false
        });
    }
    handleItemClick(index) {
        const prevIndex = this.state.currentIndex;
        this.selectItem(index);
        setTimeout(() => {
            if (prevIndex === 0 && index > 1) {
                this.prevItem();
                return;
            }
            if (prevIndex === (this.state.items.length - 1) && index === 0) {
                this.nextItem();
                return;
            }
            index > prevIndex ? this.nextItem() : this.prevItem();
            // this.carousel.innerSlider.slickGoTo(index);
        }, 0);
    }
    handleAnimationEnd() {
        this.setState({
            animateDetails: false
        });
    }
    initAnimation() {
        if (this.props.isMobile) return;
        setTimeout(() => {
            this.setState({
                animateDetails: true
            });
        }, 100);
    }
    render() {
        return (
            <Container name="pedals">
                <Content>
                    <TitleContainer>
                        <Title>דיסטורשן</Title>
                        <div>
                            <SubtitleImage src={subtitleImg} />
                        </div>
                        <CreditText>מילים וצלילים: יוסי סאסי</CreditText>
                    </TitleContainer>
                    <ReactAudioPlayer
                        src={`${audioFilesPath}${this.state.currentItem.filename}`}
                        ref={node => this.player = node}
                        onEnded={this.pauseAudio}
                    />
                    <DetailsContainer>
                        <DynamicArrowContainer onClick={this.nextItem} />
                        <PedalDetails
                            isAudioPlaying={this.state.isAudioPlaying}
                            title={this.state.currentItem.title}
                            text={this.state.currentItem.text}
                            onPlayerClick={this.handlePlayerClick}
                            audioPosition={this.state.audioPosition}
                            onAnimationEnd={this.handleAnimationEnd}
                            playAnimation={this.state.animateDetails}
                        />
                        <DynamicArrowContainer left onClick={this.prevItem} />
                    </DetailsContainer>
                    <ListContainer>
                        <PedalList
                            items={this.state.items}
                            settings={this.carouselSettings}
                            nodeHandler={this.setCarouselNode}
                            onItemClick={this.handleItemClick}
                        />
                    </ListContainer>
                </Content>
            </Container>
        )
    }
}

export default PedalSection;


// WEBPACK FOOTER //
// ./src/containers/PedalSection.jsx